import { formatTL, formatDate } from "./format";

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const tl = (v, d = 2) => esc(formatTL(v, d));

const kirilimHtml = (baslik, satirlar) => `
  <div class="kutu">
    <div class="kutu-baslik">${esc(baslik)}</div>
    ${satirlar.length === 0 ? '<p class="bos">Açık bakiye yok.</p>' : `
    <table class="kirilim">
      <tbody>
        ${satirlar.map((s) => `<tr><td>${esc(s.ad)}</td><td class="sag muted">${s.adet} dosya</td><td class="sag kalin">${tl(s.kalan)}</td></tr>`).join("")}
      </tbody>
      <tfoot><tr><td>Toplam</td><td class="sag muted">${satirlar.reduce((a, s) => a + s.adet, 0)} dosya</td><td class="sag kalin">${tl(satirlar.reduce((a, s) => a + s.kalan, 0))}</td></tr></tfoot>
    </table>`}
  </div>`;

export const takipRaporuHtml = (rapor, donem, hazirlayan) => {
  const g = rapor.genel;
  const d = rapor.durumlar;
  const simdi = new Date();
  const tarihStr = `${simdi.toLocaleDateString("tr-TR")} ${simdi.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })}`;
  const durumSatir = (ad, x, renk) => `
    <tr>
      <td><span class="nokta" style="background:${renk}"></span>${ad}</td>
      <td class="sag">${x.adet}</td>
      <td class="sag">${tl(x.fatura_tutari)}</td>
      <td class="sag yesil">${tl(x.tahsil_edilen)}</td>
      <td class="sag kalin">${tl(x.kalan)}</td>
      <td class="sag muted">${g.fatura_tutari > 0 ? ((x.fatura_tutari / g.fatura_tutari) * 100).toLocaleString("tr-TR", { maximumFractionDigits: 1 }) : "0"}%</td>
    </tr>`;

  const satirlar = rapor.eksik_odemeler.map((e, i) => `
    <tr class="${e.gecikme_gun != null ? "gecikmis" : ""}">
      <td class="sag muted">${i + 1}</td>
      <td class="nowrap">${esc(formatDate(e.tarih))}</td>
      <td class="nowrap">${esc(e.belge_no || "—")}</td>
      <td class="nowrap mavi">${esc(e.is_emri_no || "—")}</td>
      <td class="nowrap plaka">${esc(e.plaka || "—")}</td>
      <td class="nowrap">${esc(e.dosya_no || "—")}</td>
      <td class="kes">${esc(e.sigorta_sirketi || e.musteri || "—")}${e.sigorta_sirketi && e.musteri && e.sigorta_sirketi !== e.musteri ? `<div class="alt">${esc(e.musteri)}</div>` : ""}</td>
      <td class="sag nowrap">${tl(e.fatura_tutari)}</td>
      <td class="sag nowrap yesil">${tl(e.tahsil_edilen)}</td>
      <td class="sag nowrap kalin turuncu">${tl(e.eksik)}${e.kdv_haric_tahsilat ? ' <span class="etiket">KDV\'siz</span>' : ""}</td>
      <td class="nowrap">${e.vade_tarihi ? esc(formatDate(e.vade_tarihi)) : '<span class="muted">—</span>'}</td>
      <td class="nowrap ${e.gecikme_gun != null ? "kirmizi kalin" : "muted"}">${e.gecikme_gun != null ? `${e.gecikme_gun} gün gecikti` : e.vade_tarihi ? "Vadesinde" : "Vade yok"}</td>
      <td class="nowrap">${esc(e.durum)}</td>
    </tr>`).join("");

  return `<!DOCTYPE html>
<html lang="tr"><head><meta charset="utf-8">
<title>Takip Raporu — ${esc(donem)}</title>
<style>
  @page { size: A4 landscape; margin: 12mm 12mm 16mm 12mm; }
  * { box-sizing: border-box; }
  body { font-family: "Segoe UI", Arial, Helvetica, sans-serif; color: #111827; font-size: 10.5px; margin: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  .sayfa { padding: 18px 22px; }
  @media print { .sayfa { padding: 0; } }
  header { display: flex; align-items: center; justify-content: space-between; border-bottom: 2.5px solid #0f172a; padding-bottom: 10px; margin-bottom: 14px; }
  .marka { display: flex; align-items: center; gap: 12px; }
  .logo { width: 44px; height: 44px; border-radius: 10px; background: #f5b400; color: #0f172a; font-weight: 800; font-size: 18px; display: flex; align-items: center; justify-content: center; letter-spacing: -0.5px; }
  .marka h1 { margin: 0; font-size: 17px; letter-spacing: -0.2px; }
  .marka p { margin: 2px 0 0; color: #6b7280; font-size: 10px; }
  .rapor-bilgi { text-align: right; }
  .rapor-bilgi h2 { margin: 0; font-size: 15px; color: #0f172a; }
  .rapor-bilgi .donem { font-size: 12px; font-weight: 600; color: #b45309; margin-top: 2px; }
  .rapor-bilgi .meta { color: #6b7280; font-size: 9.5px; margin-top: 3px; }
  .kpi { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; margin-bottom: 12px; }
  .kpi > div { border: 1px solid #e5e7eb; border-radius: 8px; padding: 8px 10px; background: #fafafa; break-inside: avoid; }
  .kpi .l { font-size: 8.5px; text-transform: uppercase; letter-spacing: 0.6px; color: #6b7280; font-weight: 600; }
  .kpi .v { font-size: 15px; font-weight: 800; margin-top: 3px; font-variant-numeric: tabular-nums; }
  .kpi .s { font-size: 8.5px; color: #6b7280; margin-top: 2px; }
  .kpi .bar { height: 5px; background: #e5e7eb; border-radius: 3px; margin-top: 6px; overflow: hidden; }
  .kpi .bar > div { height: 100%; background: #059669; }
  .kpi .yesil .v { color: #047857; } .kpi .turuncu .v { color: #b45309; } .kpi .gri .v { color: #374151; } .kpi .kirmizi .v { color: #b91c1c; }
  .bolum-baslik { font-size: 10px; text-transform: uppercase; letter-spacing: 0.8px; color: #374151; font-weight: 700; margin: 12px 0 6px; padding-left: 8px; border-left: 3px solid #f5b400; }
  table { width: 100%; border-collapse: collapse; }
  thead th { background: #0f172a; color: #fff; font-size: 8.5px; text-transform: uppercase; letter-spacing: 0.5px; padding: 6px 6px; text-align: left; font-weight: 600; }
  thead th.sag { text-align: right; }
  tbody td { padding: 5px 6px; border-bottom: 1px solid #e5e7eb; vertical-align: top; }
  tbody tr:nth-child(even) td { background: #f9fafb; }
  tbody tr.gecikmis td { background: #fef2f2; }
  tfoot td { padding: 6px; font-weight: 700; border-top: 2px solid #0f172a; background: #f3f4f6; }
  tr { break-inside: avoid; }
  thead { display: table-header-group; }
  .sag { text-align: right; font-variant-numeric: tabular-nums; }
  .nowrap { white-space: nowrap; }
  .kes { max-width: 200px; overflow: hidden; text-overflow: ellipsis; }
  .alt { font-size: 8.5px; color: #6b7280; }
  .muted { color: #6b7280; } .kalin { font-weight: 700; } .yesil { color: #047857; } .turuncu { color: #b45309; } .kirmizi { color: #b91c1c; } .mavi { color: #0369a1; }
  .plaka { font-weight: 700; letter-spacing: 0.4px; text-transform: uppercase; }
  .etiket { display: inline-block; font-size: 7.5px; background: #fef3c7; color: #92400e; border-radius: 3px; padding: 0 3px; font-weight: 600; vertical-align: middle; }
  .nokta { display: inline-block; width: 8px; height: 8px; border-radius: 50%; margin-right: 6px; vertical-align: middle; }
  .ozet-tablo td, .ozet-tablo th { padding: 6px 8px; }
  .grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
  .kutu { border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden; break-inside: avoid; }
  .kutu-baslik { background: #f3f4f6; padding: 6px 8px; font-size: 8.5px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; color: #374151; }
  .kirilim td { padding: 4px 8px; border-bottom: 1px solid #f1f5f9; }
  .kirilim tfoot td { border-top: 1.5px solid #cbd5e1; background: #f8fafc; }
  .bos { padding: 8px; color: #6b7280; margin: 0; }
  footer { margin-top: 18px; padding-top: 8px; border-top: 1px solid #e5e7eb; display: flex; justify-content: space-between; color: #6b7280; font-size: 8.5px; }
  .imza { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 24px; margin-top: 26px; break-inside: avoid; }
  .imza > div { border-top: 1px solid #9ca3af; padding-top: 4px; font-size: 9px; color: #374151; text-align: center; }
  .not { font-size: 8.5px; color: #6b7280; margin-top: 6px; }
</style></head>
<body><div class="sayfa">
  <header>
    <div class="marka">
      <div class="logo">3A</div>
      <div><h1>3A Otomotiv</h1><p>Finansal Yönetim · Tahsilat Takip Birimi</p></div>
    </div>
    <div class="rapor-bilgi">
      <h2>Dosya Takip &amp; Eksik Ödeme Raporu</h2>
      <div class="donem">Dönem: ${esc(donem)}</div>
      <div class="meta">Rapor tarihi: ${esc(tarihStr)}${hazirlayan ? ` · Hazırlayan: ${esc(hazirlayan)}` : ""}</div>
    </div>
  </header>

  <div class="kpi">
    <div><div class="l">Kesilen Dosya</div><div class="v">${tl(g.fatura_tutari, 0)}</div><div class="s">${g.adet} dosya · Tahsilat %${g.tahsilat_orani.toLocaleString("tr-TR")}</div><div class="bar"><div style="width:${Math.min(g.tahsilat_orani, 100)}%"></div></div></div>
    <div class="yesil"><div class="l">Tam Ödenen</div><div class="v">${tl(d.tam_odenen.tahsil_edilen, 0)}</div><div class="s">${d.tam_odenen.adet} dosya</div></div>
    <div class="turuncu"><div class="l">Kısmi / Eksik Ödeme</div><div class="v">${tl(d.kismi.kalan, 0)}</div><div class="s">${d.kismi.adet} dosya · fatura ${tl(d.kismi.fatura_tutari, 0)}</div></div>
    <div class="gri"><div class="l">Hiç Ödenmemiş</div><div class="v">${tl(d.odenmemis.kalan, 0)}</div><div class="s">${d.odenmemis.adet} dosya</div></div>
    <div class="kirmizi"><div class="l">Vadesi Geçen</div><div class="v">${tl(d.vadesi_gecen.kalan, 0)}</div><div class="s">${d.vadesi_gecen.adet} dosya</div></div>
  </div>

  <div class="bolum-baslik">Ödeme Durumu Özeti</div>
  <table class="ozet-tablo">
    <thead><tr><th>Durum</th><th class="sag">Dosya</th><th class="sag">Fatura Tutarı</th><th class="sag">Tahsil Edilen</th><th class="sag">Kalan</th><th class="sag">Pay</th></tr></thead>
    <tbody>
      ${durumSatir("Tam Ödenen", d.tam_odenen, "#059669")}
      ${durumSatir("Kısmi / Eksik Ödeme", d.kismi, "#d97706")}
      ${durumSatir("Hiç Ödenmemiş", d.odenmemis, "#6b7280")}
      ${durumSatir("Vadesi Geçen (açık dosyalar içinde)", d.vadesi_gecen, "#dc2626")}
    </tbody>
    <tfoot><tr><td>Genel Toplam</td><td class="sag">${g.adet}</td><td class="sag">${tl(g.fatura_tutari)}</td><td class="sag yesil">${tl(g.tahsil_edilen)}</td><td class="sag">${tl(g.kalan)}</td><td class="sag">%${g.tahsilat_orani.toLocaleString("tr-TR")} tahsil</td></tr></tfoot>
  </table>
  <p class="not">* Vadesi Geçen satırı Kısmi ve Hiç Ödenmemiş dosyaların alt kümesidir; genel toplama ayrıca dahil edilmez.</p>

  <div class="bolum-baslik">Eksik Ödemeler — Açık Kalan Dosyalar (${rapor.eksik_odemeler.length} dosya · Toplam eksik ${tl(g.kalan)})</div>
  <table>
    <thead><tr>
      <th class="sag">#</th><th>Tarih</th><th>Fatura No</th><th>İş Emri</th><th>Plaka</th><th>Dosya No</th><th>Sigorta / Müşteri</th>
      <th class="sag">Fatura</th><th class="sag">Tahsil Edilen</th><th class="sag">Eksik Kalan</th><th>Vade</th><th>Vade Durumu</th><th>Durum</th>
    </tr></thead>
    <tbody>${satirlar || '<tr><td colspan="13" class="muted" style="text-align:center;padding:14px">Bu dönemde eksik ödeme yok — tüm dosyalar tahsil edilmiş.</td></tr>'}</tbody>
    ${rapor.eksik_odemeler.length ? `<tfoot><tr><td colspan="7">Toplam (${rapor.eksik_odemeler.length} dosya)</td><td class="sag">${tl(rapor.eksik_odemeler.reduce((a, e) => a + e.fatura_tutari, 0))}</td><td class="sag yesil">${tl(rapor.eksik_odemeler.reduce((a, e) => a + e.tahsil_edilen, 0))}</td><td class="sag turuncu">${tl(g.kalan)}</td><td colspan="3"></td></tr></tfoot>` : ""}
  </table>

  <div class="bolum-baslik">Açık Bakiye Kırılımı</div>
  <div class="grid2">
    ${kirilimHtml("Sigorta / Müşteri Bazında", rapor.sigorta_bazinda)}
    ${kirilimHtml("Kanal Bazında", rapor.kanal_bazinda)}
  </div>

  <div class="imza"><div>Hazırlayan</div><div>Kontrol Eden</div><div>Onaylayan</div></div>
  <footer><span>3A Finans · Bu rapor sistem verilerinden otomatik oluşturulmuştur.</span><span>${esc(tarihStr)}</span></footer>
</div>
<script>window.addEventListener("load", function () { setTimeout(function () { window.print(); }, 150); });</script>
</body></html>`;
};

export const takipRaporuYazdir = (rapor, donem, hazirlayan) => {
  const w = window.open("", "_blank", "width=1200,height=850");
  if (!w) return false;
  w.document.open();
  w.document.write(takipRaporuHtml(rapor, donem, hazirlayan));
  w.document.close();
  return true;
};
